import { createSelector } from '@reduxjs/toolkit';
import { CHAT_HISTORY_WINDOW } from 'modules/chat/domain/constants';
import { RootState } from 'store/store';

const selectChatSlice = createSelector(
  (state: RootState) => state.chat,
  (state) => state,
);

export const selectChatMessages = createSelector([selectChatSlice], (state) =>
  state.messages.slice(-CHAT_HISTORY_WINDOW),
);

export const selectChatIsSending = createSelector([selectChatSlice], (state) => state.isSending);

export const selectChatIsClearing = createSelector([selectChatSlice], (state) => state.isClearing);

export const selectChatIsLoadingHistory = createSelector([selectChatSlice], (state) => state.isLoadingHistory);

export const selectChatError = createSelector([selectChatSlice], (state) => state.error);

export const selectChatQuota = createSelector([selectChatSlice], (state) => state.quota);

export const selectChatPendingConfirmation = createSelector(
  [selectChatSlice],
  (state) => state.pendingConfirmation ?? null,
);
